import { render } from "./Drawer.vue?vue&type=template&id=63c112e2&scoped=true&ts=true&lang=pug"
import script from "./Drawer.vue?vue&type=script&lang=ts"
export * from "./Drawer.vue?vue&type=script&lang=ts"

import "./Drawer.vue?vue&type=style&index=0&id=63c112e2&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c112e2"]])

export default __exports__